import React from 'react';

import { api } from '@/utils/api';

import { useExtensionContext } from '~/components/extension.context';

export const useLoginExtension = () => {
  const [{ extensionId, extensionConnectedStatus }, { postMessage }] = useExtensionContext();
  const generateTokenMutation = api.auth.token2.useMutation();
  const mutateAsync = generateTokenMutation.mutateAsync;

  React.useEffect(() => {
    if (extensionId && extensionConnectedStatus === 'connected') {
      mutateAsync({
        userAgent: window.navigator.userAgent,
      })
        .then((token) => postMessage({ type: 'LOGIN', data: { token } }))
        .catch((error) => {
          console.error(error);
        });
    }
  }, [mutateAsync, extensionId, extensionConnectedStatus, postMessage]);
};
